<script>

/**
 * ==================================
 *  Chart Vue.js Component
 * ==================================
 *
 * <doughnut-chart>...</doughnut-chart>
 */

import VueCharts from 'vue-chartjs'
import { Doughnut, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins

export default {
  extends: VueCharts.Doughnut, 
  mixins: [reactiveProp],
  props: ['options'],
 
  mounted: function() {
    this.renderChart(this.chartData, this.options);
  }
}
</script>
